export const apiKey = 'b4120025-3b95-4b55-8625-871876de8700'
export const apiScopes = ['api://82dac785-23db-499d-9d8a-2f2352ad05a3/rooming.read']
export const apiAuthority = 'https://login.microsoftonline.com/29e7a041-29b3-485a-ba7a-808f0fe2c812'
export const frontendBasePath = 'https://beijing2022rooming.ita.sport'
export const backendBasePath = 'https://beijingroomingbackend.azurewebsites.net'
export const pageSize = 20
export const appInsightsBackend = 'InstrumentationKey=80dc2df4-6007-49e7-8558-b7026d9897ce;IngestionEndpoint=https://switzerlandnorth-0.in.applicationinsights.azure.com/'
export const colorHighlight = '#00205b'